export default __webpack_public_path__ + "static/media/cloth_2.fba7e001.jpg";